/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum MasterAccountAuthType {
    azure_active_directory = 'azure_active_directory',
    corestack = 'corestack',
    azure_sso = 'azure_sso',
    AD_LDAP = 'AD_LDAP',
    CAS = 'CAS',
    Okta = 'Okta',
    onelogin = 'onelogin',
    openid_connect = 'openid_connect'
}
